/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Cloudflare_TermInputs */

const en_marketing_faq_cloudflare_term = /** @type {(inputs: Marketing_Faq_Cloudflare_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a Cloudflare account?`)
};

const es_marketing_faq_cloudflare_term = /** @type {(inputs: Marketing_Faq_Cloudflare_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesito una cuenta de Cloudflare?`)
};

const fr_marketing_faq_cloudflare_term = /** @type {(inputs: Marketing_Faq_Cloudflare_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ai-je besoin d'un compte Cloudflare ?`)
};

/**
* | output |
* | --- |
* | "Do I need a Cloudflare account?" |
*
* @param {Marketing_Faq_Cloudflare_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_cloudflare_term = /** @type {((inputs?: Marketing_Faq_Cloudflare_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Cloudflare_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_cloudflare_term(inputs)
	if (locale === "es") return es_marketing_faq_cloudflare_term(inputs)
	return fr_marketing_faq_cloudflare_term(inputs)
});